export let environment;

switch (document.location.host) {
  case 'localhost:4200':
    environment = {
      production: false,
      BACKEND: 'http://192.168.0.250:4002/Ftago/',
      cidi: {
        url: 'https://cidi.test.cba.gov.ar/portal-publico/?app=299',
        redirecTo: 'localhost:4200/fiscaliago'
      },
      afip: {
        url: '',
        redirecTo: ''
      }
    };
    break;
  case '192.168.0.250':
    environment = {
      production: false,
      name: 'eval',
      BACKEND: 'http://192.168.0.250:4001/Ftago/',
      cidi: {
        url: ''
      },
      afip: {
        url: '',
        redirecTo: ''
      }
    };
    break;
  case '192.168.0.250:8080': // acceder al docker de testing via ip local
    environment = {
      production: false,
      name: 'eval',
      BACKEND: 'http://192.168.0.250:4002/Ftago/',
      cidi: {
        url: ''
      },
      afip: {
        url: '',
        redirecTo: ''
      }
    };
    break;
    case '190.17.14.195': // acceder al docker de testing via ip remoto
      environment = {
        production: false,
        name: 'eval',
        BACKEND: 'http://190.17.14.195:4002/Ftago/',
        cidi: {
          url: ''
        },
        afip: {
          url: '',
          redirecTo: ''
        }
      };
      break;
  case 'ftago.rentascordoba.gob.ar':
    environment = {
      production: true,
      BACKEND: 'https://ftago-back.rentascordoba.gob.ar/Ftago/',
      cidi: {
        // url:  "https://cidiv1.cba.gov.ar/Cuenta/LoginInterno?app=299"
        url:  'https://cidi.cba.gov.ar/portal-publico/?app=299',
        redirecTo: 'ftago.rentascordoba.gob.ar/fiscaliago'
      },
      afip: {
        url: 'https://app.rentascordoba.gob.ar/rentas/servlet/as3tdgr_ftago',
        redirecTo: 'ftago.rentascordoba.gob.ar/fiscaliago'
      }
    };
    break;
  case 'ftago-preprod.rentascordoba.gob.ar':
    environment = {
      production: false,
      BACKEND: 'https://ftago-back-preprod.rentascordoba.gob.ar/Ftago/',
      cidi: {
        url: 'https://cidi.test.cba.gov.ar/portal-publico/?app=299',
        redirecTo: 'ftago-preprod.rentascordoba.gob.ar/fiscaliago'
      },
      afip: {
        url: '',
        redirecTo: 'ftago-preprod.rentascordoba.gob.ar/fiscaliago'
      }
    };
    break;
  case 'ftago-desa.rentascordoba.gob.ar':
    environment = {
      production: false,
      BACKEND: 'https://ftago-back-desa.rentascordoba.gob.ar/Ftago/',
      cidi: {
        url: 'https://cidi.test.cba.gov.ar/portal-publico/?app=299',
        redirecTo: 'ftago-desa.rentascordoba.gob.ar/fiscaliago'
      },
      afip: {
        url: '',
        redirecTo: ''
      }
    };
    break;
  case 'ftago-test.rentascordoba.gob.ar':
    environment = {
      production: false,
      BACKEND: 'https://ftago-back-test.rentascordoba.gob.ar/Ftago/',
      cidi: {
        url: 'https://cidi.test.cba.gov.ar/portal-publico/?app=299',
        redirecTo: 'ftago-test.rentascordoba.gob.ar/fiscaliago'
      },
      afip: {
        url: '',
        redirecTo: ''
      }
    };
    break;
  case '127.0.0.1':
    environment = {
      production: false,
      BACKEND: 'http://localhost:4000/Ftago/',
      cidi: {
        url: 'https://cidi.test.cba.gov.ar/portal-publico/?app=299',
        redirecTo: 'http://localhost:4200/fiscaliago'
      },
      afip: {
        url: '',
        redirecTo: ''
      }
    };
    break;
  default:
    environment = {
      production: false,
      BACKEND: 'unit-test.url/',
      cidi: {
        url: ''
      },
      afip: {
        url: '',
        redirecTo: ''
      }
    };
    break;
}
